import ReactDOM from 'react-dom';
import App from './App';
import ReactGA from 'react-ga';

declare const GA_ID: string;
ReactGA.initialize(GA_ID ?? 'UA-3615640-14');

const mountNode = document.getElementById('app');
ReactDOM.render(<App />, mountNode);
